import {
  put
} from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';
import packageJson from '../../../package.json';

export function* initSettingsSaga(action) {
  // console.log('GETTING SETTINGS')
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {

    yield put(actions.initSettingsStart());
    try {
      let response = {};
      let fake = {};

      // if(1===1){//COMMENT OUT IF TESTING SERVER


      //COMMENT IN IF TESTING SERVER

      response = yield axios.post(
        '/settings',
        {
          rMac: rMac || '',
          bToken: token,
          sessionToken:sessionToken
        },
      ).then(res => {

        return JSON.parse(res.data.settings)

      })
      ///////////////

      fake.data = [{

        wifiEquipment: [
          {
            name: 'Askey Wave 2- RAC2V1K',
            type: 'Router',
            mac: '94917f247ab3'
          }
        ],
        changeLog: [
          {
            user: 'P2987748',
            date: '05/08/19 at 8:00am',
            changes: 'Network Optimized'
          },
          {
            user: 'P2987748',
            date: '05/08/19 at 10:00am',
            changes: 'Network Optimized'
          },
          {
            user: 'P2987748',
            date: '05/09/19 at 4:30pm',
            changes: 'Changed password'
          },
          {
            user: 'P2987748',
            date: '05/09/19 at 7:20am',
            changes: 'Router rebooted'
          },
          {
            user: 'John Smith',
            date: '05/09/19 at 8:00am',
            changes: 'Roku Paused'
          },
        ],

      }]

      yield put(actions.setSettings(fake.data, response));//COMMENT THIS IN IF TESTING SERVER
    } catch (error) {
      console.error('THERES INIT SETTINGS ERROR', error)
      yield put(actions.fetchSettingsFailed());
    }
  } else {
    //console.log('NO TOKEN')
    yield put(actions.fetchSettingsFailed());
  }

}

export function* changeNamePassSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  const eventName = 'SSID/Password';
  const eventType = 'Default Network - SSID Updated';
  const divId = yield sessionStorage.getItem('divId');
  const user = yield sessionStorage.getItem('userId');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    let endpoint = action.t && action.t === 'n'?'/settingsWifiName':'/settingsWifiNamePass'
    try {
      const response = yield axios.post(
        endpoint,
        {
          rMac: rMac || '',
          bToken: token,
          name: action.name,
          password: action.password,
          accountNumber: accountNumber,
          eventName: eventName,
          eventType: eventType,
          divId: divId,
          user: user,
          sessionToken:sessionToken
        },
        {
          validateStatus: false
        }

      );
      if(response.data.status === 200){
        yield put(actions.initSettings(action));
        yield put(actions.changeSettingsSuccess());
        yield put(actions.refreshDevices());
        }else{
          // console.log('THERES CHANGE NAME OR PASSWORD ERROR')
          yield put(actions.changeSettingsFailed(response.status));
        }

    } catch (error) {
      console.error('THERES CHANGE PASSWORD ERROR', error)
      yield put(actions.changeSettingsFailed());
    }
  } else {
    //console.log('NO TOKEN')
    yield put(actions.changeSettingsFailed());

  }


}
export function* rebootRouterSaga(action) {
  const all = action.all;
  const restore = action.restore;
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  const eventName = 'Reboot-Initiate';
  const eventType = 'Troubleshooting - Router Reboot Initiate';
  const divId = yield sessionStorage.getItem('divId');
  const user = yield sessionStorage.getItem('userId');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  let endpoint = all?'/rebootAll':(restore?'/restoreRouter':'/rebootRouter')
  if (sessionToken) {
    try {
      let response = {};

      response = yield axios.post(
        endpoint,
        {
          rMac: rMac || '',
          bToken: token,
          accountNumber: accountNumber,
          eventName: eventName,
          eventType: eventType,
          divId: divId,
          user: user,
          sessionToken:sessionToken
        }
      )
      //response = {data: {status: 500}};
      //response = {data: {status: 200}};
      if(response.data.status === 200){
        var timerStart = new Date();
        if(restore){
          yield put(actions.serviceRestoreSuccess());
        }else{
          yield put(actions.changeSettingsSuccess());
        }
        yield put(actions.restarting(timerStart));

        yield put(actions.checkWan(rMac,token, sessionToken, restore?1000:packageJson.firstCheckWanWait, timerStart));
        }else{
      // console.log('THERES A REBOOT ERROR')
      yield put(actions.changeSettingsFailed());
      yield put(actions.getFirmwareUpdateFailed());
        }

    } catch (error) {
      console.error('THERES A REBOOT ERROR', error)
      yield put(actions.changeSettingsFailed());
      yield put(actions.getFirmwareUpdateFailed());
    }
  } else {
    //console.log('NO TOKEN')
    yield put(actions.changeSettingsFailed());
    yield put(actions.getFirmwareUpdateFailed());

  }

}
export function* resetRouterSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  const eventName = 'Factory Reset - Initiate';
  const eventType = 'Troubleshooting - Factory Reset Initiate';
  const divId = yield sessionStorage.getItem('divId');
  const user = yield sessionStorage.getItem('userId');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      let response = {};

      response = yield axios.post(
        '/resetRouter',
        {
          rMac: rMac || '',
          bToken: token,
          accountNumber: accountNumber,
          eventName: eventName,
          eventType: eventType,
          divId: divId,
          user: user,
          sessionToken:sessionToken
        }
      )
      if(response.data.status === 200){
        var timerStart = new Date();
        yield put(actions.changeSettingsSuccess());
        yield put(actions.restarting(timerStart));
        yield put(actions.checkWan(rMac,token, sessionToken, packageJson.firstCheckWanWait, timerStart));
        yield put(actions.getSecondSsid());
        }else{
      // console.log('THERES A RESET ERROR')
      yield put(actions.changeSettingsFailed());
        }
      } catch (error) {
        console.error('THERES A RESET ERROR', error)
        yield put(actions.changeSettingsFailed());
      }

  } else {
    //console.log('NO TOKEN')
    yield put(actions.changeSettingsFailed());

  }
}
export function* optimizeRouterSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  const eventName = 'Router Optimization';
  const eventType = 'Router Optimization - Success';
  const divId = yield sessionStorage.getItem('divId');
  const user = yield sessionStorage.getItem('userId');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {

    try {
      yield put(actions.setOptimizeRouterSpinnerUpdate(true));
      let response = {};
      response = yield axios.post(
        '/optimizeRouter',
        {
          rMac: rMac || '',
          bToken: token,
          accountNumber: accountNumber,
          eventName: eventName,
          eventType: eventType,
          divId: divId,
          user: user,
          sessionToken:sessionToken
        }
      )
      if(response.data.status === 200){
        yield put(actions.refreshDevices());
        yield put(actions.changeSettingsSuccess());
        // yield put(actions.restarting());

        //countDown clock needs to display exact count down even though we switch between pages.
        //In order to do that, we need to persist time at which count down starts
        var timerStart = new Date();
        yield put(actions.checkWan(rMac,token, sessionToken, packageJson.firstCheckWanWait, timerStart));
        yield put(actions.setOptimizeRouterSpinnerUpdate(false));
      }else{
      // console.log('THERES A OPTIMIZE ROUTER ERROR')
      yield put(actions.changeSettingsFailed());
      yield put(actions.setOptimizeRouterSpinnerUpdate(false));
        }
    } catch (error) {
      console.error('THERES A OPTIMIZE ROUTER ERROR', error)
      yield put(actions.changeSettingsFailed());
      yield put(actions.setOptimizeRouterSpinnerUpdate(false));
    }
  } else {
    //console.log('NO TOKEN')
    yield put(actions.changeSettingsFailed());

  }

}
export function* updateFirmwareSaga(action) {
  // console.log('upgrade saga')
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');

  if (sessionToken) {
    yield put(actions.setFirmwareSpinnerUpdate(true));
    try {
      let response = {};
      response = yield axios.post(
        '/updateFirmware',
        {
          rMac: rMac || '',
          bToken: token,
          sessionToken:sessionToken
        }
      )
      if(response.data.status === 200){
        // window.alert('Firmware update has been initiated')

        let timerStart = Date.now()

        yield put(actions.checkFirmware(null,null,null,1000,timerStart));
        //yield put(actions.setFirmwareSpinnerUpdate());

      }/*else if(response.data.status === 204){
      window.alert('Router has the latest firmware')
      }*/
      else{
        // console.log('THERES A UPDATE FIRMWARE ERROR')

      yield put(actions.changeSettingsFailed());

      }

    } catch (error) {
      // console.error('THERES A UPDATE FIRMWARE ERROR', error)
      yield put(actions.changeSettingsFailed());
    }
  } else {
    //console.log('NO TOKEN')
    yield put(actions.changeSettingsFailed());

  }

}

export function* getWINVersion(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      let response = {};
      response = yield axios.get(
        '/version',
      )
      if(response.data){
        yield put(actions.setWINVersion(response.data));
      }
    } catch (error){
      // console.log('Could not get WIN version')
    }
  }
}

export function* getFirmwareUpdateSaga(action) {
  // //console.log('called from GET FIRM UPDATE METHOD')
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    // console.log('GET FIRMWARE UPDATE')
    yield put(actions.getFirmwareUpdateStart());
    try {
      let response = {};
      response = yield axios.post(
        '/getFirmwareUpdate',
        {
          rMac: rMac || '',
          bToken: token,
          sessionToken:sessionToken
        }
      )
      // console.log('GET FIRMWARE UPDATE', response)

      if(response.data.status === 200){
        // console.log('GET FIRMWARE UPDATE', response.data)
        //response.data.message.firmwareDisplayUpdateSpinner = true;
        yield put(actions.setFirmwareUpdate(response.data.message));
        if((!action.isInitial && response.data.message.summaryState && (response.data.message.summaryState === 'failed' || !(response.data.message.summaryState === 'updated' || response.data.message.summaryState === 'skipped' )))){
           var timerStart = new Date();
           yield put(actions.checkFirmware(rMac,token,sessionToken,packageJson.firstCheckWanWait,timerStart));

         }
        }else{
      // console.log('THERES AN ERROR IN GETTING FIRMWARE UPDATE')
        //yield put(actions.getFirmwareUpdateFailed());
        yield put(actions.getFirmwareUpdateFailed());
        yield put(actions.wanConnected());
        yield put(actions.getAll());
        yield put(actions.changeSettingsFailed());
      }

    } catch (error) {
      console.error('THERES AN ERROR IN GETTING FIRMWARE UPDATE', error)
      yield put(actions.getFirmwareUpdateFailed());
    }
  } else {
    //console.log('NO TOKEN')
    yield put(actions.getFirmwareUpdateFailed());
  }


}
export function* runSpeedTestSaga(action) {
  // console.log('upgrade saga')
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');

  if (sessionToken) {
    // yield put(actions.setFirmwareSpinnerUpdate());//make new runspeedteststart function to clear out redux
    try {
      let response = {};
      response = yield axios.post(
        '/runSpeedTest',
        {
          rMac: rMac || '',
          bToken: token,
          sessionToken:sessionToken
        }
      )
      if(response.data.status === 200){

        //SEND TO REDUX AND DISPLAY
        // console.log('SPEEDTEST SUCCESSFUL', response.data)
        yield put(actions.getSpeedTest())
      }else{

      yield put(actions.changeSettingsFailed());
      //console.log('FAILED RUNNING SPEED TEST', response.data)

      }

    } catch (error) {
      yield put(actions.changeSettingsFailed());
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.changeSettingsFailed());

  }

}
export function* getSpeedTestSaga(action) {
  // console.log('called from GET FIRM UPDATE METHOD')
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    // console.log('GET FIRMWARE UPDATE')
    yield put(actions.getFirmwareUpdateStart());//change to getSpeedTestStart
    try {
      let response = {};
      response = yield axios.post(
        '/getSpeedTest',
        {
          rMac: rMac || '',
          bToken: token,
          sessionToken:sessionToken
        }
      )
      // console.log('GET FIRMWARE UPDATE', response)

      if(response.data.status === 200){
        // console.log('GET FIRMWARE UPDATE', response.data)
        //response.data.message.firmwareDisplayUpdateSpinner = true;
        //console.log('SUCCESS GETTING SPEED TEST', response.data)
        //FUNCTION FOR SETTING IN REDUX
        }else{
          //console.log('FAILED GETTING SPEED TEST', response.data)

        yield put(actions.changeSettingsFailed());
      }

    } catch (error) {
      console.error('THERES AN ERROR IN GETTING FIRMWARE UPDATE', error)
      yield put(actions.changeSettingsFailed());
    }
  } else {
    //console.log('NO TOKEN')
    yield put(actions.changeSettingsFailed());
  }


}
export function* checkFirmwareSaga(action) {
  let timerStart
  if(action.timerStart){
    timerStart=action.timerStart
  }else{
    timerStart = Date.now()
  }
  // console.log('called from check firmware method');
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }
  yield delay(action.wait)
  if (sessionToken) {
  try {
    let response = {};
        response = yield axios.post(
          '/getFirmwareUpdate',
          { rMac: rMac || '',
            bToken: token,
            sessionToken:sessionToken }
        ).then(res=>{
          return res
        })
        //console.log('firware response :::', response);
        if(response.data.status === 200){
          if(response.data.message.updatedAt){
            let updatedAt = new Date(response.data.message.updatedAt)
            let milliUpdatedAt = updatedAt.getTime()
            // console.log('HAS DATE', action.timerStart, milliUpdatedAt)


            if(timerStart < milliUpdatedAt){
              // console.log('start less than updatedAt', timerStart, milliUpdatedAt)

              if((response.data.message.summaryState && response.data.message.summaryState === 'updated')
              || (response.data.message.summaryState && response.data.message.summaryState === 'failed')
              || (response.data.message.summaryState && response.data.message.summaryState === 'skipped')){
                if((response.data.message.summaryState && response.data.message.summaryState === 'failed')){
                  yield put(actions.setFirmwareUpdate(response.data.message));
                  yield put(actions.getFirmwareUpdateFailed());
                  yield put(actions.wanConnected());
                  yield put(actions.getAll());
                  yield put(actions.changeSettingsFailed());
                }else{

                // response.data.message.firmwareDisplayUpdateSpinner = false;
                  yield put(actions.setFirmwareUpdate(response.data.message));
                  yield put(actions.checkWan(rMac,token, sessionToken, 1000, timerStart));
                  }
                  yield put(actions.setFirmwareSpinnerUpdate(false));
                } else {
                //response.data.message.firmwareDisplayUpdateSpinner = true;
                yield put(actions.setFirmwareSpinnerUpdate(true));
                yield put(actions.setFirmwareUpdate(response.data.message));
                yield put(actions.checkFirmware(rMac, token, sessionToken, packageJson.reCheckWanWait, timerStart));
                }
            }else{
              // console.log('start greater than updatedAt', timerStart, milliUpdatedAt)

            // response.data.message.firmwareDisplayUpdateSpinner = false;
            yield put(actions.setFirmwareSpinnerUpdate(false));
              yield put(actions.setFirmwareUpdate(response.data.message));
              yield put(actions.checkWan(rMac,token, sessionToken, 1000, timerStart));
            }
            }else{
              // console.log('DOING ELSE')

            // response.data.message.firmwareDisplayUpdateSpinner = false;
            yield put(actions.setFirmwareSpinnerUpdate(false));
              yield put(actions.setFirmwareUpdate(response.data.message));
              yield put(actions.checkWan(rMac,token, sessionToken, 1000, timerStart));
            }


        }else{
          // console.log('THERES AN ERROR IN GETTING FIRMWARE UPDATE')
              yield put(actions.getFirmwareUpdateFailed());
              yield put(actions.wanConnected());
              yield put(actions.getAll());
              yield put(actions.changeSettingsFailed());
        }

    // yield put(actions.setWan(response));
  } catch (error) {
    yield put(actions.getFirmwareUpdateFailed());
    yield put(actions.fetchWanFailed());
  }
} else {
  console.log('NO TOKEN')
 }
}
